export default function WhyMoneyMart({
  badge,
  title,
  description,
  items = [],
}) {
  return (
    <section id="why" className="py-20 bg-white">
      <div className="container mx-auto px-6">

        <div className="max-w-3xl mx-auto text-center">

          <span className="text-primary font-semibold uppercase tracking-wider">
            {badge}
          </span>

          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            {title}
          </h2>

          <p className="mt-5 text-lg leading-8 text-slate-600">
            {description}
          </p>

        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8 mt-16">

          {items.map((reason) => {
            const Icon = reason.icon;

            return (
              <div
                key={reason.title}
                className="rounded-2xl border border-slate-200 bg-white p-8 hover:border-primary hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center justify-center h-14 w-14 rounded-xl bg-primary/10 text-primary">
                  <Icon className="h-7 w-7" />
                </div>

                <h3 className="mt-6 text-xl font-semibold">
                  {reason.title}
                </h3>

                <p className="mt-4 text-slate-600 leading-7">
                  {reason.description}
                </p>
              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
}